module.exports = __webpack_public_path__ + "media/music/saw_lead_0-e6546377.mp3";